export const theme = Object.freeze({
  backgrounds: {
    bodyPrimary: '#FDF7F2',
    bodySecondary: '#FFFFFF',
    buttonPrimary: '#F59256',
    buttonSecondary: '#FFFFFF',
    loaderPrimary: '#F59256',
    input: '#FDF7F2',
    backdrop: 'blur(4px)',
    modalOverlay: 'rgba(49, 49, 49, 0.7)',
  },
  fontColors: {
    primary: '#111111',
    secondary: '#000000',
    white: '#FFFFFF',
    buttonPrimary: '#111111',
    buttonSecondary: '#F59256',
    inputTextColor: 'rgba(17, 17, 17, 0.6)',
    blueLink: '#3091EB',
    grey: '#535353',
    navFont: '#181C27',
  },
  hoverButtonColor: {
    primary: '#FF6101',
  },
  transitions: {
    primary: '',
  },

  fontFamily: { main: 'Manrope', secondary: 'Poppins' },

  fontStyle: { main: 'normal' },
  fonts: {
    letterSpacing: '0.04em',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
  },
  fontSizes: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '28px',
    xxxxl: '36px',
    xxxxxl: '68px',
    xxxl_increased: '32px',
    xxxxl_increased: '48px',
  },
  shadows: {
    searchBox: '7px 4px 14px rgba(49, 21, 4, 0.07)',
    modal: '7px 4px 14px rgba(0, 0, 0, 0.11)',
  },
  borders: {
    input: '1px solid rgba(245, 146, 86, 0.5)',
    buttonModal: '2px solid #f59256',
  },
  borderRadius: {
    main: '40px',
    secondary: '20px',
    userInfo: '0px 40px 40px 0px',
  },
  transition: { first: '250ms cubic-bezier(0.57, 0.21, 0.69, 1.25)' },
});
